var menu = document.getElementById('hamburger');
var hasAnchor = document.querySelectorAll('.menu__hasAnchor');
// var hamburger = document.getElementsByClassName('.hamburger');

function hamburgerMenu() {
    menu.classList.toggle('hamburger_close');
    document.getElementById("menu").classList.toggle('menu_open');
    document.querySelector(".header").classList.toggle('menuOpened');
    document.body.classList.toggle('menuIsOpen');
    if (document.getElementById("menuCollapsed")) {
        document.getElementById("menuCollapsed").classList.toggle('menu-content_open');
    }
}

// Attiva il menu con clic
menu.onclick = function() {
    hamburgerMenu();
};


// Attiva il menu con Invio
menu.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
        hamburgerMenu();
    }
});

// Gestione del clic sui link con ancora
for (anchor = 0; anchor < hasAnchor.length; anchor++) {
  hasAnchor[anchor].addEventListener('click', function() {
    console.log('Anchor Clicked');
    hamburgerMenu();
  });
}



// Rendi il div targettabile
var hamburger = document.getElementById('hamburger');
hamburger.setAttribute('tabindex', '0');

// Aggiungi un evento di focus o keypress
hamburger.addEventListener('focus', () => {
    console.log('Hamburger div focused!');
});
